<template>
  <div class="d-flex fd-column ai-center">
    <div>
      <span class="CONFIRMATION-ICON">
        <p class="text-bold m-t-3 h5 p-b-6 text-center:mo m-x-1:mo">Sorry, we are experiencing
        some trouble. Please try again</p>
        <div>
          <button
              @click.prevent="retry"
              class="btn btn-sm btn-lg:t">Retry</button>
        </div>
      </span>
    </div>

    <p class="text-center p-x-1 p-b-3">
      Visit
      <router-link to="/" class="link">ProReferral.com</router-link>
      to discover how we can help with your next home project
    </p>
  </div>
</template>
<script>
export default {
  name: 'error-review',
  mounted () {
    this.$events.$emit(this.$events.REVIEWS_ERROR);
  },
  methods: {
    retry () {
      this.$events.$emit(this.$events.REVIEWS_RETRY);
      this.$emit('retry-review');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .CONFIRMATION-ICON {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 18*$unit 0;
  }
</style>
